import { Button, Col, Form, Row, Select } from "antd";
import React, { useEffect, useState } from "react";
import { FormInputItem } from "../../components/formInput";
import {
  BankOutlined,
  FieldNumberOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import { AGENT_BANK_CREATE, BANK_TYPE } from "../../lib/config";
import { CreateDataOnServer, GetDataFromServer } from "../../lib/api";

export default function AgentBankForm({ closeDrawer }) {
  const { access_token, csrf_token, ui_size } = useSelector(
    (state) => state.user
  );
  const [loading, setLoading] = useState(false);
  const [bankList, setBankList] = useState([]);
  const [form] = Form.useForm();

  async function getDataList() {
    await GetDataFromServer(BANK_TYPE, access_token)
      .then(({ data: { data: res, total } }) => {
        setBankList(res);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.error || "Connection Error");
      });
  }

  useEffect(() => {
    getDataList();
  }, []);

  async function submitHandler(values) {
    setLoading(true);

    CreateDataOnServer(AGENT_BANK_CREATE, values, access_token, csrf_token)
      .then(() => {
        toast.success("Created bank account successfully");
        setLoading(false);
        closeDrawer(true);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.message);
      });
  }

  const BANK_ICON_MAP = {
    KBZ_PAY: "/assets/kbz pay.svg",
    WAVE_PAY: "/assets/wave pay.svg",
    AYA_PAY: "/assets/aya pay.svg",
    CB_PAY: "/assets/cb pay.svg",
    CB_BANK: "/assets/cb bank.svg",
    AYA_BANK: "/assets/aya bank.svg",
    KBZ_BANK: "/assets/kbz bank.svg",
  
  };
  function renderBankOption(value){
    const iconPath = BANK_ICON_MAP[value];
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img 
          src={iconPath} 
          alt={value} 
          style={{ width: 25, height: 25, marginRight: 8, borderRadius:"5px" }} 
        />
        <span>{value.replace(/_/g, ' ')}</span>
      </div>
    );
  };

  return (
    <Form
      size={ui_size}
      form={form}
      onFinish={submitHandler}
      layout="vertical"
    >
      <Row gutter={[16, 0]}>
        <Col span={12}>
          <FormInputItem
            label="Account Name"
            name="acc_name"
            placeholder="Name"
            icon={<UserOutlined />}
            rules={[{ required: true }]}
          />
        </Col>
        <Col span={12}>
          <Form.Item
            label="Bank Type"
            name="bank_type"
            rules={[{ required: true}]}
          >
            <Select
              placeholder={
                <span>
                  <BankOutlined style={{ marginRight: 8 }} />
                  Select Bank Type
                </span>
              }
              options={bankList.map((value) => ({
                label: renderBankOption(value),
                value: value,
              }))}
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={[16, 0]}>
        <Col span={12}>
          <FormInputItem
            label="Account No."
            name="acc_number"
            placeholder="Account Number"
            icon={<FieldNumberOutlined />}
            rules={[{ required: true}]}
          />
        </Col>
      </Row>

      <Row>
        <Col span={24} align="right">
          <Button type="primary" htmlType="submit" loading={loading}>
            Create
          </Button>
          <Button
            onClick={() => closeDrawer(false)}
            style={{ marginLeft: "16px" }}
          >
            Cancel
          </Button>
        </Col>
      </Row>
    </Form>
  );
}
